/* eslint-disable eol-last */
/* eslint-disable no-unused-vars */
/* eslint-disable space-before-function-paren */
/* eslint-disable quotes */
/* eslint-disable no-multi-spaces */
/* eslint-disable keyword-spacing */
/* eslint-disable space-before-blocks */
/* eslint-disable spaced-comment */
/* eslint-disable comma-spacing */
/* eslint-disable one-var */
/* eslint-disable semi */
/* eslint-disable comma-dangle */
/* eslint-disable import/first */
import axios from 'axios' 

// 设置默认
axios.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest',
  "Content-Type": "application/json",
  "X-CSRF-TOKEN" : window.csrf_token||'no token'
}
// 创建 axios 实例
const service = axios.create({})

axios.defaults.timeout = 50000
if (process.env.BASE_AP) {
  // axios.defaults.baseURL = process.env.BASE_API
}
//axios携带cookie
// axios.defaults.withCredentials = true
// loadinginstace 遮罩层控制
let loadinginstace
// pending 存放正在请求的ajax
const pending = {}
const CancelToken = axios.CancelToken

const removePending = (key, isRequest = false) => {
  if (pending[key] && isRequest) {
    pending[key]('取消重复请求')
  }
  delete pending[key]
}

const getRequestIdentify = (config, isReuest = false) => {
  let url = config.url
  if (isReuest) {
    url = config.url.substring(1, config.url.length)
  }
  return config.method === 'get' ? encodeURIComponent(url + JSON.stringify(config.params)) : encodeURIComponent(config.url + JSON.stringify(config.data))
}

// service.defaults.cancelToken = new CancelToken(c => { cancel = c })

// POST传参序列化(添加请求拦截器)
// 在发送请求之前做某件事
service.interceptors.request.use(config => {
  // 拦截重复请求(即当前正在进行的相同请求)
  let requestData = getRequestIdentify(config, true)
  // removePending(requestData, true)
  // config.cancelToken = new CancelToken((c) => {
  //   pending[requestData] = c
  // })
  // 设置以 form 表单的形式提交参数
  if (config.formData) {
    // JSON 转换为 FormData
    const formData = new FormData()
    Object.keys(config.data).forEach(key => formData.append(key, config.data[key]))
    config.data = formData
  }
  
  //这是element-ui的效果，全页面遮罩，中间带有加载圈
  // loadinginstace = Loading.service({
  //   fullscreen: true,
  //   lock: true,
  //   text: 'Loading',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0, 0, 0, 0.7)'
  // })
  // loadinginstace.close()
  return config
}, error => {
  // 关闭遮罩层
  // loadinginstace.close()
  alert("错误的传参", 'fail')
  return Promise.reject(error)
})

// 响应拦截器即异常处理
service.interceptors.response.use(response => {
  // 把已经完成的请求从 pending 中移除
  let requestData = getRequestIdentify(response.config)
  // removePending(requestData)
  // loadinginstace.close()
  // eslint-disable-next-line eqeqeq
  if (response.data.code == 401) {
    store.commit('LogOut')
    router.push({ path: '/login' })
  }
  return response
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '错误请求'
        break;
      case 401:
        err.message = '未授权，请重新登录';
        // location.href = '/login';
        break;
      case 403:
        err.message = '拒绝访问'
        break;
      case 404:
        err.message = '请求错误,未找到该资源'
        break;
      case 405:
        err.message = '请求方法未允许'
        break;
      case 408:
        err.message = '请求超时'
        break;
      case 500:
        err.message = '服务器端出错'
        break;
      case 501:
        err.message = '网络未实现'
        break;
      case 502:
        err.message = '网络错误'
        break;
      case 503:
        err.message = '服务不可用'
        break;
      case 504:
        err.message = '网络超时'
        break;
      case 505:
        err.message = 'http版本不支持该请求'
        break;
      default:
        err.message = `连接错误${err.response.status}`
    }
  } else {
    if (err.message === '取消重复请求') {
      return Promise.reject(err)
    } else {
      err.message = "连接到服务器失败"
    }
  }
  // loadinginstace.close()
  // Message.error({ message: err.message })
  /*
  if (err && window.Glob.httpErrLog) {
    console.log(err)
  }
  */
  return Promise.reject(err)
})

export default service